<template>
  <div class="flex flex-col gap-2" v-if="users.length !== 0">
    <t-text size="xl" class="font-semibold" color="black">{{ title }}</t-text>
    <div
      class="flex items-center justify-between gap-4 py-2 cursor-pointer"
      v-for="user in users"
      @click="goToUser(user)"
      :key="`related_user_${user.id}`"
    >
      <img :src="user.avatar" class="w-8 h-8 rounded-full" />
      <div class="flex items-center gap-1 mr-auto">
        <t-text color="black" class="font-semibold truncate">{{ user.fullname }}</t-text>
        <img src="@/assets/static/icons/icon-verified__badge.svg" class="w-3 h-3 my-auto" v-if="user.is_verified" />
      </div>
      <ph-caret-right size="24" :color="$helpers.getCorrectColor(themeColorHEX)" />
    </div>
    <t-button border size="sm" ref="btn" @click.native="getUsers()" v-if="expanded">
      <t-text class="font-semibold">{{ $t('components.relatedUsers.seeall') }}</t-text>
    </t-button>

    <!-- CURTAIN -->
    <t-curtain ref="curtain">
      <t-curtain-tab group="related" name="related" :fullscreen="allUsers.length > 5" :title="title">
        <t-main-item
          v-for="user in allUsers"
          class="text-black cursor-pointer"
          :image="user.profile.find(item => item.name === 'avatar').value"
          imageSize="32"
          :text="user.fullname"
          imageCircle
          :imageBranded="false"
          :key="`all_related_users_${user.id}`"
          @clickLink="goToUser(user)"
        >
          <template #textRelative v-if="user.is_verified">
            <img src="@/assets/static/icons/icon-verified__badge.svg" class="w-3 h-3 my-auto" />
          </template>
        </t-main-item>
        <observer
          @on-change="loadMore"
          v-if="page != totalPages && page < totalPages && !loadingMore"
          class="flex items-center justify-center"
        >
          <t-loader-circle />
        </observer>
      </t-curtain-tab>
    </t-curtain>
    <!-- CURTAIN -->
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import AXIOS from '@/integrations/axios'
  import Observer from 'vue-intersection-observer'
  export default {
    name: 'related-users',
    props: {
      entity: {
        type: String,
        required: true
      },
      title: {
        type: String,
        required: true
      },
      users: {
        type: Array,
        required: true
      },
      expanded: {
        type: Boolean,
        required: true
      }
    },
    data() {
      return {
        allUsers: [],
        page: 1,
        totalPages: 0,
        loadingMore: false
      }
    },
    components: {
      Observer
    },
    computed: {
      ...mapGetters(['themeColorHEX']),
      ...mapGetters('user', ['userId', 'userProfileModule'])
    },
    methods: {
      getUsers() {
        this.$refs.btn.toggleLoad()
        AXIOS.get(
          `/user/related-list?entity=${this.entity}&id=${
            this.$route.params.profile_id || this.$route.params.id || this.$route.params.item_id
          }`
        ).then(res => {
          this.allUsers = res.data
          this.totalPages = res.headers['x-pagination-page-count']
          this.$refs.btn.toggleLoad()
          this.$refs.curtain.tab('related/related')
        })
      },
      loadMore(entry, unobserve) {
        if (!entry.isIntersecting || this.loadingMore) return
        if (this.page >= this.totalPages) return unobserve()
        this.loadingMore = true
        AXIOS.get(
          `/user/related-list?entity=${this.entity}&id=${this.$route.params.profile_id || this.$route.params.id}&page=${this.page + 1}`
        ).then(res => {
          this.allUsers = [...this.allUsers, ...res.data]
          this.totalPages = res.headers['x-pagination-page-count']
          this.loadingMore = false
          this.page++
        })
      },
      goToUser(user) {
        if (user.id !== this.userId) this.$router.push({name: 'profile.other', params: {id: user.id}})
        else this.$router.push({name: 'profile.index', params: {app_module_id: this.userProfileModule.app_module_id}})
      }
    }
  }
</script>
